module.exports = __webpack_public_path__ + "img/vertical_3_5_9016.ec1afb57.png";